module.exports = __webpack_public_path__ + "static/media/logo.c624b60a.svg";